module.exports = __webpack_public_path__ + "img/Portal-CheckInicons-healthy.57e17a72.png";